import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.41,26.59l-7.35-7.36a11,11,0,1,0-2.83,2.83l7.36,7.35a2,2,0,0,0,2.82-2.82ZM13,20a7,7,0,1,1,7-7A7,7,0,0,1,13,20Z"/><path d="M17,14H14v3a1,1,0,0,1-1.69.7A1,1,0,0,1,12,17V14H9a1,1,0,0,1-.7-.29A1,1,0,0,1,9,12h3V9a1,1,0,0,1,2,0v3h3a1,1,0,0,1,0,2Z"/>';
export var ZoomInSVG = function ZoomInSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ZoomInSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ZoomInSVG);